import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import {
  Button,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  FormText,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap'
import ReactDatetime from 'react-datetime'
import moment from 'moment'
import numeral from 'numeral'

const ExpensesForm = ({
  onSubmit,
  loading,
  register,
  errors,
  readOnly,
  accounts,
  getValues,
}) => (
  <Form onSubmit={onSubmit} noValidate autoComplete="off">
    <Input name="id" type="hidden" innerRef={register({
      required: true,
      validate: value => value !== '0' && value !== ''
    })} />
    {errors.id && (
      <h3 className="text-danger">Seleccione un gasto</h3>
    )}
    <div className="pl-lg-4">
      <Row>
        <Col md="6">
          <FormGroup>
            <Input
              id="amount-expense"
              autoComplete="off"
              placeholder="Monto"
              type="text"
              disabled={true}
              name="amount"
              innerRef={register({
                required: true,
                pattern: /^\d+(\.\d)?/,
              })}
            />
            {errors.amount && errors.amount.type === 'required' && (
              <FormText color="primary">
                Ingrese un monto
              </FormText>
            )}
            {errors.amount && errors.amount.type === 'pattern' && (
              <FormText color="primary">
                Ingrese sólo dígitos
              </FormText>
            )}
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Input
              id="expense-account"
              placeholder="Cuenta..."
              type="select"
              name="account"
              innerRef={register({
                required: true,
                validate: value => {
                  const expenseAmount = getValues()['amount'];
                  if (value === 'Seleccione una opción') {
                    return 'Seleccione una cuenta válida';
                  }

                  let amount = value && accounts.find(acc => acc.id === parseInt(value));
                  amount = amount && numeral(amount.amount)
                  let difference = 0;
                  if (amount) {
                    difference = amount.difference(expenseAmount)
                  }
                  return (amount &&
                    amount.subtract(expenseAmount).value() >= 0
                  ) || `El monto sobrepasa la cuenta seleccionada por ${difference} `;
                }
              })}
            >
              {[<option key={'emptyValue'}>Seleccione una opción</option>]
                .concat(accounts
                  .map(account => <option value={account.id} key={account.id}>{account.name}</option>)
                )
              }
            </Input>
            {errors.account && (
              <FormText color="primary">
                Seleccione una cuenta válida
              </FormText>
            )}
            {errors.account && errors.account.message}
          </FormGroup>
        </Col>
        <Col md="12">
          <FormGroup>
            <Input
              id="expense-pay-description"
              placeholder="Descripción..."
              rows="3"
              type="textarea"
              name="description"
              innerRef={register({ required: true })}
            />
            {errors.description && (
              <FormText color="primary">
                Ingrese una descripción
              </FormText>
            )}
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <InputGroup className="input-group-alternative">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="ni ni-calendar-grid-58" />
                </InputGroupText>
              </InputGroupAddon>
              <ReactDatetime
                className="form-control-alternative"
                id="expense-pay-date"
                timeFormat={false}
                closeOnSelect={true}
                inputProps={{
                  autoComplete: 'off',
                  placeholder: 'Fecha',
                  name: 'date',
                  ref: register({
                    required: true,
                    validate: value => moment(value, 'DD/MM/YYYY').isValid()
                  }),
                }}
              />
              {errors.date && errors.date.type === 'required' && (
                <FormText color="primary">
                  Seleccione una fecha.
                </FormText>
              )}
              {errors.date && errors.date.type === 'validate' && (
                <FormText color="primary">
                  Ingrese una fecha válida o seleccione una en el calendario.
                </FormText>
              )}
            </InputGroup>
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Input
              id="expense-voucher"
              placeholder="Subir voucher"
              type="file"
              accept=".pdf"
              name="expense_voucher"
              innerRef={register}
            />
          </FormGroup>
        </Col>
        <Col md="12">
          {!readOnly && (<Button disabled={loading} color="primary" size="sm" className="float-right">
            Realizar pago
          </Button>)}
        </Col>
      </Row>
    </div>
  </Form>
)

ExpensesForm.propTypes = {
  loading: PropTypes.bool,
  readOnly: PropTypes.bool,
  onSubmit: PropTypes.func,
  register: PropTypes.func,
  errors: PropTypes.shape({
    name: PropTypes.shape({
      type: PropTypes.string
    })
  }),
  enabledPayExpenseButton: PropTypes.bool,
}

ExpensesForm.defaultProps = {
  loading: false,
  readOnly: false,
  onSubmit: noop,
  errors: {}
}

export default ExpensesForm
